"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateLoanShareCalculationReportSchema = exports.CreateLoanShareCalculationSchema = exports.CreateLoanShareholderWithApartmentSchema = exports.LoanCalculationSnapshotApiSchema = exports.CreateLoanCalculationSnapshotSchema = exports.LoanCalculationSnapshotSchema = exports.LoanCalculationSnapshotDbRowSchema = exports.CreateActiveLoanSchema = exports.CreateLoanRowSchema = exports.CreateLoanSchema = exports.LoanApiSchema = exports.LoanApiStrictSchema = exports.LoanDbRowSchema = exports.LoanDbRowStrictSchema = exports.CreateLoanEventRowSchema = exports.CreateLoanEventSchema = exports.LoanEventSchema = exports.LoanEventRowSchema = exports.CreateLoanShareholderRowSchema = exports.CreateLoanShareholderSchema = exports.LoanShareholderWithApartmentSchema = exports.LoanShareholderSchema = exports.LoanShareholderRowSchema = void 0;
const loans_1 = require("../enums/loans");
const zod_1 = require("zod");
const finance_1 = require("../enums/finance");
const months = {
    1: { key: 'jan', days: 31 },
    // Disregard leap year extra day for february to make things simple
    2: { key: 'feb', days: 28 },
    3: { key: 'mar', days: 31 },
    4: { key: 'apr', days: 30 },
    5: { key: 'may', days: 31 },
    6: { key: 'june', days: 30 },
    7: { key: 'july', days: 31 },
    8: { key: 'aug', days: 31 },
    9: { key: 'sep', days: 30 },
    10: { key: 'oct', days: 31 },
    11: { key: 'nov', days: 30 },
    12: { key: 'dec', days: 31 },
};
const DayMonthValueSchema = zod_1.z
    .object({
    day: zod_1.z.number().int().min(1),
    month: zod_1.z.number().int().min(1).max(12),
})
    .refine((value) => { var _a; return value.day <= ((_a = months[value.month]) === null || _a === void 0 ? void 0 : _a.days); }, 'Too many days for given month');
const BillingBasisInputSchema = zod_1.z.object({
    amount: zod_1.z.number(),
    locked: zod_1.z.boolean(),
});
/* Loan shareholder types */
exports.LoanShareholderRowSchema = zod_1.z.object({
    uuid: zod_1.z.string().uuid(),
    created_at: zod_1.z.string().datetime(),
    updated_at: zod_1.z.string().datetime(),
    loan_uuid: zod_1.z.string().uuid(),
    loan_name: zod_1.z.string(),
    company_uuid: zod_1.z.string().uuid(),
    company_name: zod_1.z.string().uuid(),
    share_group_uuid: zod_1.z.string().uuid(),
    billing_basis: zod_1.z.nativeEnum(finance_1.PaymentProductBillingBasis),
    billing_basis_squares: BillingBasisInputSchema.nullable().optional(),
    billing_basis_weighted_squares: BillingBasisInputSchema.nullable().optional(),
    billing_basis_shares: BillingBasisInputSchema.nullable().optional(),
    billing_basis_residents: BillingBasisInputSchema.nullable().optional(),
    billing_basis_pieces: BillingBasisInputSchema.nullable().optional(),
    original_loan_share_amount: zod_1.z.number(),
    original_units: zod_1.z.number(),
    currency: zod_1.z.string(),
    contract_uuid: zod_1.z.string().uuid().nullable().optional(),
});
const loanShareholderRowShape = exports.LoanShareholderRowSchema.shape;
exports.LoanShareholderSchema = zod_1.z.object({
    uuid: loanShareholderRowShape.uuid,
    createdAt: loanShareholderRowShape.created_at,
    updatedAt: loanShareholderRowShape.updated_at,
    loanUUID: loanShareholderRowShape.loan_uuid,
    loanName: loanShareholderRowShape.loan_name,
    companyUUID: loanShareholderRowShape.company_uuid,
    companyName: loanShareholderRowShape.company_name,
    shareGroupUUID: loanShareholderRowShape.share_group_uuid,
    billingBasis: loanShareholderRowShape.billing_basis,
    billingBasisSquares: loanShareholderRowShape.billing_basis_squares,
    billingBasisWeightedSquares: loanShareholderRowShape.billing_basis_weighted_squares,
    billingBasisShares: loanShareholderRowShape.billing_basis_shares,
    billingBasisResidents: loanShareholderRowShape.billing_basis_residents,
    billingBasisPieces: loanShareholderRowShape.billing_basis_pieces,
    originalLoanShareAmount: loanShareholderRowShape.original_loan_share_amount,
    originalUnits: loanShareholderRowShape.original_units,
    currency: loanShareholderRowShape.currency,
    contractUUID: loanShareholderRowShape.contract_uuid,
});
exports.LoanShareholderWithApartmentSchema = exports.LoanShareholderSchema.extend({
    apartment: zod_1.z.object({
        uuid: zod_1.z.string().uuid().optional(),
        label: zod_1.z.string().optional(),
        identifier: zod_1.z.string().optional(),
    }),
});
exports.CreateLoanShareholderSchema = exports.LoanShareholderSchema.omit({
    uuid: true,
    createdAt: true,
    updatedAt: true,
    companyUUID: true,
    companyName: true,
    loanUUID: true,
}).extend({
    locked: zod_1.z.boolean(),
});
exports.CreateLoanShareholderRowSchema = exports.LoanShareholderRowSchema.omit({
    uuid: true,
    created_at: true,
    updated_at: true,
    company_uuid: true,
    company_name: true,
});
/* Loan event types */
exports.LoanEventRowSchema = zod_1.z.object({
    uuid: zod_1.z.string().uuid(),
    created_at: zod_1.z.string().datetime(),
    updated_at: zod_1.z.string().datetime(),
    company_uuid: zod_1.z.string().uuid(),
    loan_calculation_snapshot_uuid: zod_1.z.string().uuid().nullable().optional(),
    loan_uuid: zod_1.z.string().uuid(),
    event_date: zod_1.z.string().date(),
    register_date: zod_1.z.string().date(),
    type: zod_1.z.nativeEnum(loans_1.LoanEventType),
    used: zod_1.z.boolean().nullable().optional(),
    events_used: zod_1.z.array(zod_1.z.string().uuid()).nullable().optional(),
    amount: zod_1.z.number(),
    units: zod_1.z.number().nullable().optional(),
    balance_adjustment_amount: zod_1.z.number().nullable().optional(),
    adjusted_amount: zod_1.z.number().nullable().optional(),
    explanation: zod_1.z.string().nullable().optional(),
    share_group_uuid: zod_1.z.string().uuid().nullable().optional(),
    interest_amount: zod_1.z.number().nullable().optional(),
    interest_start_date: zod_1.z.string().date().nullable().optional(),
    interest_end_date: zod_1.z.string().date().nullable().optional(),
    bank_expense_amount: zod_1.z.number().nullable().optional(),
    other_expense_amount: zod_1.z.number().nullable().optional(),
    currency: zod_1.z.string(),
    deleted: zod_1.z.boolean(),
    deleted_by_author: zod_1.z.string().nullable().optional(),
});
const loanEventRowShape = exports.LoanEventRowSchema.shape;
exports.LoanEventSchema = zod_1.z.object({
    uuid: loanEventRowShape.uuid,
    createdAt: loanEventRowShape.created_at,
    updatedAt: loanEventRowShape.updated_at,
    companyUUID: loanEventRowShape.company_uuid,
    loanCalculationSnapshotUUID: loanEventRowShape.loan_calculation_snapshot_uuid,
    loanUUID: loanEventRowShape.loan_uuid,
    eventDate: loanEventRowShape.event_date,
    registerDate: loanEventRowShape.register_date,
    type: loanEventRowShape.type,
    used: loanEventRowShape.used,
    eventsUsed: loanEventRowShape.events_used,
    amount: loanEventRowShape.amount,
    units: loanEventRowShape.units,
    balanceAdjustmentAmount: loanEventRowShape.balance_adjustment_amount,
    adjustedAmount: loanEventRowShape.adjusted_amount,
    explanation: loanEventRowShape.explanation,
    shareGroupUUID: loanEventRowShape.share_group_uuid,
    interestAmount: loanEventRowShape.interest_amount,
    interestStartDate: loanEventRowShape.interest_start_date,
    interestEndDate: loanEventRowShape.interest_end_date,
    bankExpenseAmount: loanEventRowShape.bank_expense_amount,
    otherExpenseAmount: loanEventRowShape.other_expense_amount,
    currency: loanEventRowShape.currency,
    deleted: loanEventRowShape.deleted,
    deletedByAuthor: loanEventRowShape.deleted_by_author,
});
exports.CreateLoanEventSchema = exports.LoanEventSchema.omit({
    uuid: true,
    createdAt: true,
    updatedAt: true,
    companyUUID: true,
    deleted: true,
});
exports.CreateLoanEventRowSchema = exports.LoanEventRowSchema.omit({
    uuid: true,
    created_at: true,
    updated_at: true,
    company_uuid: true,
});
/* Loan entity types */
// Base schema: all fields required and non-nullable as a strict base
exports.LoanDbRowStrictSchema = zod_1.z.object({
    uuid: zod_1.z.string().uuid(),
    created_at: zod_1.z.string().datetime(),
    updated_at: zod_1.z.string().datetime(),
    name: zod_1.z.string(),
    reference_number: zod_1.z.string(),
    currency: zod_1.z.string(),
    status: zod_1.z.nativeEnum(loans_1.LoanStatus),
    company_uuid: zod_1.z.string().uuid(),
    company_name: zod_1.z.string(),
    start_date_estimated: zod_1.z.string().date(),
    end_date_estimated: zod_1.z.string().date(),
    financing_type: zod_1.z.nativeEnum(loans_1.LoanFinancingType),
    type: zod_1.z.string(),
    granted_by: zod_1.z.string(),
    duration: zod_1.z.string(),
    start_date: zod_1.z.string().date(),
    end_date: zod_1.z.string().date(),
    original_loan_amount: zod_1.z.number(),
    starting_balance: zod_1.z.number(),
    amount_drawn: zod_1.z.number(),
    date_drawn: zod_1.z.string().date(),
    drawn: zod_1.z.boolean(),
    usable_on_building_manager_certificate: zod_1.z.boolean(),
    shares_payable: zod_1.z.boolean(),
    share_payment_dates: zod_1.z.array(zod_1.z.string()),
    interest_days_month: zod_1.z.nativeEnum(loans_1.LoanInterestDaysMonth),
    interest_days_year: zod_1.z.nativeEnum(loans_1.LoanInterestDaysYear),
    interest_type: zod_1.z.string(),
    starting_interest_percentage: zod_1.z.number(),
    interest_first_due_date: zod_1.z.string().date(),
    interest_inspection_dates: zod_1.z.array(zod_1.z.string()),
    marginal_percentage: zod_1.z.number(),
    amortization_amount: zod_1.z.number(),
    amortization_first_due_date: zod_1.z.string().date(),
    amortization_dates: zod_1.z.array(zod_1.z.string()),
    starting_units: zod_1.z.number(),
    billing_basis: zod_1.z.nativeEnum(finance_1.PaymentProductBillingBasis),
    payment_product_uuid: zod_1.z.string().uuid(),
    current_form_step: zod_1.z.number(),
    reached_form_step: zod_1.z.number(),
    events: zod_1.z.array(exports.LoanEventRowSchema),
    shareholders: zod_1.z.array(exports.LoanShareholderRowSchema),
    deleted: zod_1.z.boolean(),
    deleted_by_author: zod_1.z.string(),
});
// Looser schema: allows nullable/optional fields, used for actual DB rows
exports.LoanDbRowSchema = exports.LoanDbRowStrictSchema.extend({
    uuid: exports.LoanDbRowStrictSchema.shape.uuid,
    created_at: exports.LoanDbRowStrictSchema.shape.created_at,
    updated_at: exports.LoanDbRowStrictSchema.shape.updated_at,
    name: exports.LoanDbRowStrictSchema.shape.name.trim(),
    reference_number: exports.LoanDbRowStrictSchema.shape.reference_number
        .trim()
        .nullable()
        .optional(),
    currency: exports.LoanDbRowStrictSchema.shape.currency.trim().nullable().optional(),
    status: exports.LoanDbRowStrictSchema.shape.status,
    company_uuid: exports.LoanDbRowStrictSchema.shape.company_uuid.trim(),
    company_name: exports.LoanDbRowStrictSchema.shape.company_name.trim(),
    start_date_estimated: exports.LoanDbRowStrictSchema.shape.start_date_estimated
        .trim()
        .nullable()
        .optional(),
    end_date_estimated: exports.LoanDbRowStrictSchema.shape.end_date_estimated
        .trim()
        .nullable()
        .optional(),
    financing_type: exports.LoanDbRowStrictSchema.shape.financing_type
        .nullable()
        .optional(),
    type: exports.LoanDbRowStrictSchema.shape.type.trim().nullable().optional(),
    granted_by: exports.LoanDbRowStrictSchema.shape.granted_by
        .trim()
        .nullable()
        .optional(),
    duration: exports.LoanDbRowStrictSchema.shape.duration.trim().nullable().optional(),
    start_date: exports.LoanDbRowStrictSchema.shape.start_date.nullable().optional(),
    end_date: exports.LoanDbRowStrictSchema.shape.end_date.nullable().optional(),
    original_loan_amount: exports.LoanDbRowStrictSchema.shape.original_loan_amount
        .nullable()
        .optional(),
    starting_balance: exports.LoanDbRowStrictSchema.shape.starting_balance
        .nullable()
        .optional(),
    amount_drawn: exports.LoanDbRowStrictSchema.shape.amount_drawn.nullable().optional(),
    date_drawn: exports.LoanDbRowStrictSchema.shape.date_drawn.nullable().optional(),
    drawn: exports.LoanDbRowStrictSchema.shape.drawn.nullable().optional(),
    usable_on_building_manager_certificate: exports.LoanDbRowStrictSchema.shape.usable_on_building_manager_certificate
        .nullable()
        .optional(),
    shares_payable: exports.LoanDbRowStrictSchema.shape.shares_payable
        .nullable()
        .optional(),
    share_payment_dates: exports.LoanDbRowStrictSchema.shape.share_payment_dates
        .nullable()
        .optional(),
    interest_days_month: exports.LoanDbRowStrictSchema.shape.interest_days_month
        .nullable()
        .optional(),
    interest_days_year: exports.LoanDbRowStrictSchema.shape.interest_days_year
        .nullable()
        .optional(),
    interest_type: exports.LoanDbRowStrictSchema.shape.interest_type
        .trim()
        .nullable()
        .optional(),
    starting_interest_percentage: exports.LoanDbRowStrictSchema.shape.starting_interest_percentage
        .nullable()
        .optional(),
    interest_first_due_date: exports.LoanDbRowStrictSchema.shape.interest_first_due_date
        .nullable()
        .optional(),
    interest_inspection_dates: exports.LoanDbRowStrictSchema.shape.interest_inspection_dates.nullable().optional(),
    marginal_percentage: exports.LoanDbRowStrictSchema.shape.marginal_percentage
        .nullable()
        .optional(),
    amortization_amount: exports.LoanDbRowStrictSchema.shape.amortization_amount
        .nullable()
        .optional(),
    amortization_first_due_date: exports.LoanDbRowStrictSchema.shape.amortization_first_due_date
        .nullable()
        .optional(),
    amortization_dates: exports.LoanDbRowStrictSchema.shape.amortization_dates
        .nullable()
        .optional(),
    starting_units: exports.LoanDbRowStrictSchema.shape.starting_units
        .nullable()
        .optional(),
    billing_basis: exports.LoanDbRowStrictSchema.shape.billing_basis
        .nullable()
        .optional(),
    payment_product_uuid: exports.LoanDbRowStrictSchema.shape.payment_product_uuid
        .trim()
        .nullable()
        .optional(),
    current_form_step: exports.LoanDbRowStrictSchema.shape.current_form_step
        .nullable()
        .optional(),
    reached_form_step: exports.LoanDbRowStrictSchema.shape.reached_form_step
        .nullable()
        .optional(),
    events: exports.LoanDbRowStrictSchema.shape.events.nullable().optional(),
    shareholders: exports.LoanDbRowStrictSchema.shape.shareholders.nullable().optional(),
    deleted: exports.LoanDbRowStrictSchema.shape.deleted,
    deleted_by_author: exports.LoanDbRowStrictSchema.shape.deleted_by_author
        .trim()
        .nullable()
        .optional(),
});
const loanDbRowStrictShape = exports.LoanDbRowStrictSchema.shape;
exports.LoanApiStrictSchema = zod_1.z.object({
    uuid: loanDbRowStrictShape.uuid,
    createdAt: loanDbRowStrictShape.created_at,
    updatedAt: loanDbRowStrictShape.updated_at,
    name: loanDbRowStrictShape.name,
    referenceNumber: loanDbRowStrictShape.reference_number,
    currency: loanDbRowStrictShape.currency,
    status: loanDbRowStrictShape.status,
    companyUUID: loanDbRowStrictShape.company_uuid,
    companyName: loanDbRowStrictShape.company_name,
    startDateEstimated: loanDbRowStrictShape.start_date_estimated,
    endDateEstimated: loanDbRowStrictShape.end_date_estimated,
    financingType: loanDbRowStrictShape.financing_type,
    type: loanDbRowStrictShape.type,
    grantedBy: loanDbRowStrictShape.granted_by,
    duration: loanDbRowStrictShape.duration,
    startDate: loanDbRowStrictShape.start_date,
    endDate: loanDbRowStrictShape.end_date,
    originalLoanAmount: loanDbRowStrictShape.original_loan_amount,
    startingBalance: loanDbRowStrictShape.starting_balance,
    amountDrawn: loanDbRowStrictShape.amount_drawn,
    dateDrawn: loanDbRowStrictShape.date_drawn,
    drawn: loanDbRowStrictShape.drawn,
    usableOnBuildingManagerCertificate: loanDbRowStrictShape.usable_on_building_manager_certificate,
    sharesPayable: loanDbRowStrictShape.shares_payable,
    sharePaymentDates: zod_1.z.array(DayMonthValueSchema),
    interestDaysMonth: loanDbRowStrictShape.interest_days_month,
    interestDaysYear: loanDbRowStrictShape.interest_days_year,
    interestType: loanDbRowStrictShape.interest_type,
    startingInterestPercentage: loanDbRowStrictShape.starting_interest_percentage,
    interestFirstDueDate: loanDbRowStrictShape.interest_first_due_date,
    interestInspectionDates: zod_1.z.array(DayMonthValueSchema),
    marginalPercentage: loanDbRowStrictShape.marginal_percentage,
    amortizationAmount: loanDbRowStrictShape.amortization_amount,
    amortizationFirstDueDate: loanDbRowStrictShape.amortization_first_due_date,
    amortizationDates: zod_1.z.array(DayMonthValueSchema),
    startingUnits: loanDbRowStrictShape.starting_units,
    billingBasis: loanDbRowStrictShape.billing_basis,
    paymentProductUUID: loanDbRowStrictShape.payment_product_uuid,
    currentFormStep: loanDbRowStrictShape.current_form_step,
    reachedFormStep: loanDbRowStrictShape.reached_form_step,
    events: zod_1.z.array(exports.LoanEventSchema),
    shareholders: zod_1.z.array(exports.LoanShareholderSchema),
    deleted: loanDbRowStrictShape.deleted,
    deletedByAuthor: loanDbRowStrictShape.deleted_by_author,
});
const LoanDbRowShape = exports.LoanDbRowSchema.shape;
exports.LoanApiSchema = zod_1.z.object({
    uuid: LoanDbRowShape.uuid,
    createdAt: LoanDbRowShape.created_at,
    updatedAt: LoanDbRowShape.updated_at,
    name: LoanDbRowShape.name,
    referenceNumber: LoanDbRowShape.reference_number,
    currency: LoanDbRowShape.currency,
    status: LoanDbRowShape.status,
    companyUUID: LoanDbRowShape.company_uuid,
    companyName: LoanDbRowShape.company_name,
    startDateEstimated: LoanDbRowShape.start_date_estimated,
    endDateEstimated: LoanDbRowShape.end_date_estimated,
    financingType: LoanDbRowShape.financing_type,
    type: LoanDbRowShape.type,
    grantedBy: LoanDbRowShape.granted_by,
    duration: LoanDbRowShape.duration,
    startDate: LoanDbRowShape.start_date,
    endDate: LoanDbRowShape.end_date,
    originalLoanAmount: LoanDbRowShape.original_loan_amount,
    startingBalance: LoanDbRowShape.starting_balance,
    amountDrawn: LoanDbRowShape.amount_drawn,
    dateDrawn: LoanDbRowShape.date_drawn,
    drawn: LoanDbRowShape.drawn,
    usableOnBuildingManagerCertificate: LoanDbRowShape.usable_on_building_manager_certificate,
    sharesPayable: LoanDbRowShape.shares_payable,
    sharePaymentDates: zod_1.z.array(DayMonthValueSchema),
    interestDaysMonth: LoanDbRowShape.interest_days_month,
    interestDaysYear: LoanDbRowShape.interest_days_year,
    interestType: LoanDbRowShape.interest_type,
    startingInterestPercentage: LoanDbRowShape.starting_interest_percentage,
    interestFirstDueDate: LoanDbRowShape.interest_first_due_date,
    interestInspectionDates: zod_1.z.array(DayMonthValueSchema),
    marginalPercentage: LoanDbRowShape.marginal_percentage,
    amortizationAmount: LoanDbRowShape.amortization_amount,
    amortizationFirstDueDate: LoanDbRowShape.amortization_first_due_date,
    amortizationDates: zod_1.z.array(DayMonthValueSchema),
    startingUnits: LoanDbRowShape.starting_units,
    billingBasis: LoanDbRowShape.billing_basis,
    paymentProductUUID: LoanDbRowShape.payment_product_uuid,
    currentFormStep: LoanDbRowShape.current_form_step,
    reachedFormStep: LoanDbRowShape.reached_form_step,
    events: zod_1.z.array(exports.LoanEventSchema),
    shareholders: zod_1.z.array(exports.LoanShareholderSchema),
    deleted: LoanDbRowShape.deleted,
    deletedByAuthor: LoanDbRowShape.deleted_by_author,
});
exports.CreateLoanSchema = exports.LoanApiSchema.omit({
    uuid: true,
    createdAt: true,
    updatedAt: true,
    deleted: true,
    deletedByAuthor: true,
    events: true,
}).extend({
    shareholders: zod_1.z.array(exports.CreateLoanShareholderSchema),
});
exports.CreateLoanRowSchema = exports.LoanDbRowSchema.omit({
    uuid: true,
    created_at: true,
    updated_at: true,
    events: true,
    shareholders: true,
    deleted: true,
    deleted_by_author: true,
});
exports.CreateActiveLoanSchema = exports.CreateLoanSchema.required({
    name: true,
    referenceNumber: true,
    currency: true,
    status: true,
    companyName: true,
    companyUUID: true,
    startDateEstimated: true,
    endDateEstimated: true,
    financingType: true,
    type: true,
    grantedBy: true,
    duration: true,
    startDate: true,
    endDate: true,
    originalLoanAmount: true,
    amountDrawn: true,
    dateDrawn: true,
    sharesPayable: true,
    usableOnBuildingManagerCertificate: true,
    drawn: true,
    interestDaysMonth: true,
    interestDaysYear: true,
    interestType: true,
    startingInterestPercentage: true,
    interestFirstDueDate: true,
    marginalPercentage: true,
    amortizationAmount: true,
    amortizationFirstDueDate: true,
    startingUnits: true,
    billingBasis: true,
});
/* Loan calculation snapshot related types */
exports.LoanCalculationSnapshotDbRowSchema = zod_1.z.object({
    uuid: zod_1.z.string().uuid(),
    created_at: zod_1.z.string().datetime(),
    updated_at: zod_1.z.string().datetime(),
    loan_uuid: zod_1.z.string().uuid(),
    calculation_date: zod_1.z.string().date(),
    calculation: zod_1.z.string().date(),
    calculation_version: zod_1.z.string(),
    deleted: zod_1.z.boolean().default(false),
    deleted_by_author: zod_1.z.string().nullable().optional(),
});
exports.LoanCalculationSnapshotSchema = zod_1.z.object({
    uuid: exports.LoanCalculationSnapshotDbRowSchema.shape.uuid,
    createdAt: exports.LoanCalculationSnapshotDbRowSchema.shape.created_at,
    updatedAt: exports.LoanCalculationSnapshotDbRowSchema.shape.updated_at,
    loanUUID: exports.LoanCalculationSnapshotDbRowSchema.shape.loan_uuid,
    calculationDate: exports.LoanCalculationSnapshotDbRowSchema.shape.calculation_date,
    calculation: exports.LoanCalculationSnapshotDbRowSchema.shape.calculation,
    calculationVersion: exports.LoanCalculationSnapshotDbRowSchema.shape.calculation_version,
    deleted: exports.LoanCalculationSnapshotDbRowSchema.shape.deleted,
    deletedByAuthor: exports.LoanCalculationSnapshotDbRowSchema.shape.deleted_by_author,
});
exports.CreateLoanCalculationSnapshotSchema = exports.LoanCalculationSnapshotSchema.omit({
    uuid: true,
    createdAt: true,
    updatedAt: true,
    deleted: true,
    deletedByAuthor: true,
});
exports.LoanCalculationSnapshotApiSchema = exports.LoanCalculationSnapshotSchema.omit({
    calculation: true,
});
/* Loan share calculation related types */
exports.CreateLoanShareholderWithApartmentSchema = zod_1.z.object({
    uuid: zod_1.z.string().uuid(),
    apartment: zod_1.z.object({
        uuid: zod_1.z.string().uuid(),
        label: zod_1.z.string(),
        identifier: zod_1.z.string(),
    }),
});
exports.CreateLoanShareCalculationSchema = zod_1.z.object({
    companyUUID: zod_1.z.string().uuid(),
    startDate: zod_1.z.string().date().optional(),
    endDate: zod_1.z.string().date(),
    shareholdersWithApartment: zod_1.z.array(exports.CreateLoanShareholderWithApartmentSchema),
});
exports.CreateLoanShareCalculationReportSchema = zod_1.z.object({
    loanUUID: zod_1.z.string().uuid(),
    url: zod_1.z.string().url(),
    loanCalculationSnapshotUUID: zod_1.z.string().uuid(),
});
